/**
 * ============================================================================
 * EL-ARO
 * COMPONENT: Mega Collection Products
 * ============================================================================
 */

class ElaroMegaCollectionProducts {

    constructor(root) {

        this.root = root;

        this.track = root.querySelector(
            ".elaro-mega-collection-products__track"
        );

        this.prev = root.querySelector(
            ".elaro-mega-collection-products__button--prev"
        );

        this.next = root.querySelector(
            ".elaro-mega-collection-products__button--next"
        );

        if (!this.track) {

            return;

        }

        this.resizeObserver = new ResizeObserver(() => {

            this.calculateDistance();

            this.updateButtons();

        });

        this.calculateDistance();

        this.bindEvents();

        this.resizeObserver.observe(this.track);

        requestAnimationFrame(() => {

            this.updateButtons();

        });

    }

    /*==========================================================================
      Helpers
    ==========================================================================*/

    calculateDistance() {

        const card = this.track.querySelector(
            ".elaro-mega-collection-products__card"
        );

        this.distance = card
            ? card.offsetWidth + 20
            : 240;

    }

    /*==========================================================================
      Events
    ==========================================================================*/

    bindEvents() {

        if (this.prev) {

            this.prev.addEventListener(

                "click",

                () => {

                    this.track.scrollBy({

                        left: -this.distance,

                        behavior: "smooth"

                    });

                }

            );

        }

        if (this.next) {

            this.next.addEventListener(

                "click",

                () => {

                    this.track.scrollBy({

                        left: this.distance,

                        behavior: "smooth"

                    });

                }

            );

        }

        this.track.addEventListener(

            "scroll",

            () => {

                this.updateButtons();

            }

        );

        document.addEventListener(

            "mega-products:update",

            () => {

                requestAnimationFrame(() => {

                    this.calculateDistance();

                    this.updateButtons();

                });

            }

        );

    }

    /*==========================================================================
      Buttons
    ==========================================================================*/

    updateButtons() {

        const maxScroll =

            this.track.scrollWidth -
            this.track.clientWidth;

        const currentScroll =

            Math.round(this.track.scrollLeft);

        if (this.prev) {

            this.prev.classList.toggle(

                "is-hidden",

                currentScroll <= 2

            );

        }

        if (this.next) {

            this.next.classList.toggle(

                "is-hidden",

                maxScroll <= 2 ||
                currentScroll >= maxScroll - 2

            );

        }

    }

}


/*==============================================================================
  Manager
==============================================================================*/

class ElaroMegaCollectionProductsManager {

    constructor() {

        this.initialize();

    }

    initialize() {

        document

            .querySelectorAll(".elaro-mega-collection-products")

            .forEach(root => {

                if (root.dataset.initialized === "true") {

                    return;

                }

                new ElaroMegaCollectionProducts(root);

                root.dataset.initialized = "true";

            });

    }

}


/*==============================================================================
  Initialize
==============================================================================*/

const initializeMegaCollectionProducts = () => {

    new ElaroMegaCollectionProductsManager();

};

document.addEventListener(

    "DOMContentLoaded",

    initializeMegaCollectionProducts

);

document.addEventListener(

    "shopify:section:load",

    initializeMegaCollectionProducts

);